<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
import DataTable from 'datatables.net-vue3';
import moment from 'moment';
import { usePermissions } from '@/composables/usePermissions';

export default {
    page: {
        title: "Product List",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            role:localStorage.getItem('role'),
            title: "Product List",
            items: [
                {
                text: "Device Management",
                href: "/",
                },
                {
                text: "Product List",
                active: true,
                },
            ],
        
            productList:[],
            loadingDetail:false,
            loadingRoles:true,
            ButtonSeen:true,
        };
    },
    setup() {
        const permissions = usePermissions();
        
        return {
            permissions,
        };
    },
    methods: {
        format_date(value){
            if (value) {
                return moment(String(value)).format('DD-MM-YYYY')
            }
        },
        getProductList(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'product/list')
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.productList = response.data;
                    console.log(this.productList);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },
        downloadExcel: function () {
            location.href= process.env.VUE_APP_API_BASEURL+'productlist/export';
        },
    },

    components: {
        Layout,
        PageHeader,
        DataTable,
    },

    mounted() {
        this.getProductList();
        
    },
    
};
require("@/assets/css/datatable.css");
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!--button type="button" class="btn btn-primary" @click="click"  v-if="this.role != 3">Add New Branch</button-->
    <!--router-link to="/partner/branch-create" custom v-slot="{ navigate }"><button class="btn btn-primary" @click="navigate" role="link"><i class="ri-add-line align-middle me-1"></i> Add New Product</button></router-link><br><br-->
    <div class="d-flex justify-content-end mb-3" v-if="permissions.canCreate?.value">
        <router-link :to="'/device/product-create/'" aria-selected="true" class="btn btn-success">
            Add New Product
        </router-link> &nbsp;&nbsp;&nbsp;&nbsp;
        <button v-if="permissions.canExport?.value" @click="downloadExcel()" class="btn btn-success"><i class="ri-file-excel-2-line align-middle me-1"></i> Export Excel</button><br><br>
    </div>
    <div class="card">
            <div class="card-body">
                <div class="live-preview">
                    <div class="row align-items-center g-12">
                        <div class="col-lg-12">
                            <div v-if='loadingRoles'>
                                <div class="spinner-border text-success" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="table-responsive">
                                <DataTable class="table table-striped table-nowrap mb-0"> 
                                     <thead class="table-secondary">
                                        <tr>
                                            <th>No.</th>
                                            <th scope="col" class="text-center">Image</th>
                                            <th scope="col">Name</th>      
                                            <th scope="col">Product Id</th>      
                                            <th scope="col">Model</th>
                                            <th scope="col">Capacity</th>
                                            <th scope="col">Color</th>
                                            <th scope="col">Pre Owned</th>
                                            <th scope="col">Status</th>
                                            <th scope="col">Created Date</th>
                                            <th scope="col">Created By</th>
                                            <!--th scope="col">Action</th-->
                                        </tr>
                                    </thead>

                                    <tbody>                        
                                        <tr v-for="(item, index) in productList" :key="index" class="content align-middle">
                                            <td>{{ index+1 }}</td>
                                            <td class="text-center">
                                                <img v-if="item.thumbnail" :src="item.thumbnail" alt="Product Image" class="avatar-sm img-thumbnail" style="object-fit: contain; max-height: 40px;" />
                                                <span v-else class="text-muted">-</span>
                                            </td>
                                            <td>
                                            <template v-if="permissions.canUpdate?.value">
                                                <router-link :to="'/device/product-details/'+item.id" class="fw-medium link-secondary">{{ item.product_name }} </router-link>
                                            </template>
                                            <template v-else>
                                                {{ item.product_name }}
                                            </template>
                                            </td>
                                            <td>{{ item.id }}</td>
                                            <td>{{ item.model_name }}</td>
                                            <td>{{ item.capacity_name }}</td>
                                            <td>{{ item.color_name }}</td>
                                            <td>{{ item.owned }}</td>
                                            <td v-if="item.status == 0"><span class="badge bg-success">Active</span></td>
                                            <td v-else><span class="badge bg-danger">Disabled</span></td>
                                            <td>{{ format_date(item.created_at) }}</td>                                          
                                            <td>{{ item.user_name }}</td> 
                                            <!--td>
                                                <i @click="EditBranch(item.id)" class="bx bx-edit" data-bs-toggle="modal" data-bs-target=".editBrand"></i>
                                            </td-->                                         
                                        </tr>
                                    </tbody>
                                </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

            <div class="modal fade bs-example-modal-lg ViewCustomerOrder" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                <div class="modal-dialog justify-content-center modal-lg">
                    <div class="modal-content mx-auto w-75" >
                        <div class="modal-header">
                            <h5 class="modal-title" id="myLargeModalLabel">ORDER NO.# {{orderid}}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div v-if='loadingDetail'>
                                <div class="spinner-border text-success" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="card product">
                                    <div class="card-body">
                                        <div class="row gy-8">
                                        <div class="col-md">
                                            <h4>Client's Offer</h4>
                                            <h5 class="fs-15 text-truncate">
                                            <router-link to="/ecommerce/product-detail" class="text-dark"
                                                >{{model}} {{capacity}}GB {{color}} Grade: {{grade}}</router-link
                                            >
                                            </h5>
                                            <ul class="list-inline text-muted">
                                            <li class="list-inline-item">
                                                Quantity : <span class="fw-medium">{{quantity}}</span>
                                            </li>
                                            <li class="list-inline-item">
                                                Price : <span class="fw-medium">${{customerprice}}</span>
                                            </li>
                                            <li class="list-inline-item">
                                                GP : <span class="fw-medium">5.8%</span>
                                            </li>
                                            <li class="list-inline-item">
                                                Original Price : <span class="fw-medium">$900</span>
                                            </li>
                                            </ul>

                                            <div class="col-lg-10">
                                                <div class="form-floating">
                                                    <input type="text" class="form-control" id="firstnamefloatingInput" v-model="customerRemark">                                                
                                                </div>
                                            </div>
                                        </div>                                      
                                        </div>
                                    </div>
                                    <!-- card body -->
                                    <div class="card-footer">
                                        <div class="row align-items-center gy-3">
                                        <div class="col-sm">
                                            <div class="d-flex flex-wrap my-n1">
                                            <div>
                                                <a href="javascript:void(0);" class="btn btn-secondary rounded-pill btn-label">
                                                <div class="d-flex">
                                                    <div class="flex-shrink-0">
                                                    <i class="ri-checkbox-circle-fill label-icon align-middle rounded-pill fs-16 me-2"></i>
                                                    </div>
                                                    <div class="flex-grow-1">Accept</div>
                                                </div>
                                                </a>
                                            </div>
                                            &nbsp;&nbsp;&nbsp;&nbsp;
                                            <div>
                                                <a href="javascript:void(0);" class="btn btn-danger rounded-pill btn-label">
                                                <div class="d-flex">
                                                    <div class="flex-shrink-0">
                                                    <i class="ri-arrow-go-back-line label-icon align-middle rounded-pill fs-16 me-2"></i>
                                                    </div>
                                                    <div class="flex-grow-1">Counter Offer</div>
                                                </div>
                                                </a>
                                            </div>
                                            </div>
                                        </div>
                                        
                                        </div>
                                    </div>
                                    <!-- end card footer -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- /.modal-content -->
                </div>
                <!-- /.modal-dialog -->
            </div>

            <!-- Counter Offer --------->

            <div class="modal fade bs-example-modal-lg ViewCustomerOrder" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                <div class="modal-dialog justify-content-center modal-lg">
                    <div class="modal-content mx-auto w-75" >
                        <div class="modal-header">
                            <h5 class="modal-title" id="myLargeModalLabel">ORDER NO.# {{orderid}}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div v-if='loadingDetail'>
                                <div class="spinner-border text-success" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="card product">
                                    <div class="card-body">
                                        <div class="row gy-8">
                                        <div class="col-md">
                                            <h4>Counter Offer</h4>
                                           

                                            
                                        </div>                                      
                                        </div>
                                    </div>
                                    <!-- card body -->
                                    <div class="card-footer">
                                        <div class="row align-items-center gy-3">
                                            <div class="col-sm">
                                                <div class="d-flex flex-wrap my-n1">
                                                    <div>
                                                        <a href="javascript:void(0);" class="btn btn-danger rounded-pill btn-label">
                                                        <div class="d-flex">
                                                            <div class="flex-shrink-0">
                                                            <i class="ri-arrow-go-back-line label-icon align-middle rounded-pill fs-16 me-2"></i>
                                                            </div>
                                                            <div class="flex-grow-1">Counter Offer</div>
                                                        </div>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>                                
                                        </div>
                                    </div>
                                    <!-- end card footer -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- /.modal-content -->
                </div>
                <!-- /.modal-dialog -->
            </div>

            <!-- End of Counter Offer -------->
            
            <div class="modal fade" id="exampleModalgrid" tabindex="-1" aria-labelledby="exampleModalgridLabel">
                <div class="modal-dialog modal-xl">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalgridLabel">Add New Inventory</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <form @submit="AddNewCategory" id="AddNewCategory">
                                <div class="row g-3">
                                    <div class="col-xxl-12">
                                        <div>
                                            <label for="categoryname" class="form-label">Category Name</label>
                                            <input type="text" v-model='categoryname' class="form-control" id="categoryname" placeholder="Enter Category Name" required/>
                                        </div>
                                    </div>
                                    <!--end col-->                            
                                    <div class="col-lg-12">
                                        <div class="hstack gap-2 justify-content-end">
                                            <button type="button" class="btn btn-light"
                                                data-bs-dismiss="modal">Close</button>
                                            <button type="submit" class="btn btn-primary">Submit</button>
                                        </div>
                                    </div>
                                    <!--end col-->
                                </div>
                                <!--end row-->
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        <!-- end of modal -->

    </Layout>
</template>